export default "__VITE_ASSET__BOA0$4Sh__"